// pp-cliente-orden.js — el buscador de la página /pages/cliente-orden.
//
// Liquid no lee query params, así que la página rinde OCULTOS los detalles
// de las órdenes propias (paginate by 48) y este script destapa la que pide
// ?orden= (acepta "146038", "#146038" o el name completo). Si la orden no
// está en esta página de paginate y hay más, brinca a ?page=N+1 conservando
// ?orden= (server-side paginate lee ?page=). Agotadas las páginas → estado
// "no encontrada". Sin ?orden= → de vuelta a la lista.
(function () {
  'use strict';

  var params = new URLSearchParams(window.location.search);
  var pedida = (params.get('orden') || '').trim().replace(/^#/, '');
  var loader = document.querySelector('[data-pp-orden-cargando]');
  var miss = document.querySelector('[data-pp-orden-miss]');

  function esconderLoader() {
    if (loader) loader.hidden = true;
  }

  if (!pedida) {
    window.location.replace('/pages/cliente-ordenes');
    return;
  }

  var nodos = document.querySelectorAll('[data-pp-orden]');
  var match = null;
  for (var i = 0; i < nodos.length; i++) {
    var n = nodos[i];
    if (n.getAttribute('data-orden-name') === pedida || n.getAttribute('data-orden-num') === pedida) {
      match = n;
      break;
    }
  }

  if (match) {
    esconderLoader();
    // PODA: los detalles NO pedidos se van del DOM. No es solo peso — los
    // scripts del detalle (pp-order-produccion.js) asumen UNA orden por
    // página con querySelector singular; con 47 bloques ocultos le
    // preguntarían al taller por la primera orden del DOM, no por ésta.
    for (var k = 0; k < nodos.length; k++) {
      if (nodos[k] !== match) nodos[k].parentNode.removeChild(nodos[k]);
    }
    match.hidden = false;
    document.title = '#' + pedida + ' — ' + document.title;
    return;
  }

  var pag = document.querySelector('[data-pp-orden-paginacion]');
  var pagina = pag ? parseInt(pag.getAttribute('data-pagina'), 10) : 1;
  var paginas = pag ? parseInt(pag.getAttribute('data-paginas'), 10) : 1;

  if (pagina < paginas) {
    // Brinco automático a la siguiente página de paginate, misma orden.
    params.set('page', String(pagina + 1));
    window.location.replace(window.location.pathname + '?' + params.toString());
    return;
  }

  esconderLoader();
  if (miss) miss.hidden = false;
})();
